import { resolveMount } from './resolve-mount';

/**
 * The active-mount prefix for same-origin API / data calls. Replaces the old
 * hardcoded `/orion-web` base (and the `install-root-api-mount-rewrite` hack it
 * needed). In **production** it's the real active mount:
 *   - `''`            on the symphony.wix.com root (no prefix mapped)
 *   - `/orion-web`    on manage.wix.com/orion-web    (Pepyaka strips it → pod)
 *   - `/symphony-web` on manage.wix.com/symphony-web (Pepyaka strips it → pod)
 *
 * In **dev** it stays `/orion-web`: `next dev` proxies the data layer to the
 * deployed handler via next.config's `/orion-web/api/*` rewrite, which works
 * precisely because that synthetic prefix has no local Next route (bare `/api/*`
 * would be shadowed by the local `pages/api` routes, which can't run offline).
 * This dev-only prefix goes away when the dev proxy is reworked (go-direct).
 *
 * SSR-safe: returns `''` when there's no window — the data layer only calls it
 * client-side.
 */
function apiBase(): string {
  if (typeof window === 'undefined') return '';
  if (process.env.NODE_ENV === 'development') return '/orion-web';
  return resolveMount(window.location.pathname);
}

/**
 * The shared API base for the whole client — resolved ONCE at module load (the
 * mount is stable for the page). Import this everywhere instead of calling
 * `apiBase()` per file: `apiFetch(\`${API_BASE}/api/...\`)`.
 */
export const API_BASE = apiBase();
